import { useCallback, useEffect, useState } from 'react';
import CrudTable from '../../components/CrudTable';
import { db, supabase } from '../../lib/supabase';
import { useAuth } from '../../lib/useAuth';

// QT#7: chấm công (check-in/out) + admin xác nhận công cuối tháng.
export default function AttendanceAdmin() {
  const { session, role } = useAuth();
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7)); // YYYY-MM
  const [staff, setStaff] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    supabase.from('user_profiles').select('user_id, full_name').in('role', ['staff', 'admin'])
      .then(({ data }) => setStaff(data || []));
  }, []);

  const nameOf = (id) => staff.find((s) => s.user_id === id)?.full_name || (id || '').slice(0, 8);
  const monthStart = `${month}-01`;
  const monthEnd = `${month}-31`;

  const fetchRows = useCallback(async () => {
    const { data } = await supabase
      .from('attendance').select('*')
      .gte('work_date', monthStart).lte('work_date', monthEnd)
      .order('work_date', { ascending: false });
    return data || [];
  }, [month]); // eslint-disable-line react-hooks/exhaustive-deps

  const today = new Date().toISOString().slice(0, 10);

  const punch = async (kind) => {
    if (!session) return;
    setMsg('');
    const { data: rows } = await supabase
      .from('attendance').select('*')
      .eq('staff_id', session.user.id).eq('work_date', today);
    const row = rows?.[0];
    const now = new Date().toISOString();
    if (!row) {
      await db.insert('attendance', { staff_id: session.user.id, work_date: today, [kind]: now });
    } else {
      await db.update('attendance', row.id, { [kind]: now });
    }
    setMsg(kind === 'check_in' ? '✅ Đã check-in!' : '✅ Đã check-out!');
    setRefreshKey((k) => k + 1);
  };

  const confirmMonth = async () => {
    if (!window.confirm(`Xác nhận toàn bộ công tháng ${month}? Sau khi xác nhận, bảng công được chốt.`)) return;
    const rows = await fetchRows();
    await Promise.all(
      rows.filter((r) => !r.month_confirmed).map((r) =>
        db.update('attendance', r.id, {
          month_confirmed: true,
          confirmed_by: session?.user?.id,
          confirmed_at: new Date().toISOString(),
        })
      )
    );
    setRefreshKey((k) => k + 1);
  };

  const fmtTime = (v) => (v ? new Date(v).toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' }) : '—');

  return (
    <div>
      <div className="row" style={{ marginBottom: 14 }}>
        <button className="btn btn-primary" onClick={() => punch('check_in')}>⏱️ Check-in</button>
        <button className="btn btn-secondary" onClick={() => punch('check_out')}>🏁 Check-out</button>
        {msg && <span style={{ color: 'var(--green)', fontWeight: 600 }}>{msg}</span>}
        <span style={{ flex: 1 }} />
        <input type="month" style={{ maxWidth: 170 }} value={month} onChange={(e) => { setMonth(e.target.value); setRefreshKey((k) => k + 1); }} />
        {role === 'admin' && (
          <button className="btn btn-primary" onClick={confirmMonth}>✅ Xác nhận công tháng {month}</button>
        )}
      </div>

      <CrudTable
        title={`⏱️ Bảng chấm công tháng ${month}`}
        table="attendance"
        fetchRows={fetchRows}
        refreshKey={refreshKey}
        defaults={{ staff_id: session?.user?.id, work_date: today }}
        columns={[
          { key: 'staff_id', label: 'Nhân viên', type: 'select',
            options: staff.map((s) => ({ value: s.user_id, label: s.full_name || s.user_id.slice(0, 8) })),
            render: (r) => nameOf(r.staff_id) },
          { key: 'work_date', label: 'Ngày', type: 'date', required: true },
          { key: 'check_in', label: 'Vào', type: 'datetime', render: (r) => fmtTime(r.check_in) },
          { key: 'check_out', label: 'Ra', type: 'datetime', render: (r) => fmtTime(r.check_out) },
          { key: 'note', label: 'Ghi chú', type: 'text' },
          { key: 'month_confirmed', label: 'Đã chốt', type: 'checkbox', inForm: role === 'admin' },
        ]}
        emptyText="Chưa có dữ liệu chấm công trong tháng này."
      />
    </div>
  );
}
